<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="120"
            @submit.native.prevent
          > 
            <FormItem label="中文名称：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="英文名称：" prop="nameEn">
              <Input v-model="formInline.nameEn" />
            </FormItem>
            <FormItem label="中文简称：" prop="shortName">
              <Input v-model="formInline.shortName" />
            </FormItem>
            <FormItem label="英文简称：" prop="shortNameEn">
              <Input v-model="formInline.shortNameEn" />
            </FormItem>
            <FormItem label="Logo：" prop="logo">
              <div>
                <upload
                  ref="upload3"
                  :fileList="uploadLogo"
                  :config="uploadLogoConfig"
                  @upload-ok="bannerLogoOK"
                />
              </div>
            </FormItem>
            <FormItem label="首页图：" prop="cover">
              <div>
                <upload
                  ref="upload1"
                  :fileList="uploadCover"
                  :config="uploadCoverConfig"
                  @upload-ok="bannerOK"
                />
              </div>
            </FormItem>
            <FormItem label="内页图：" prop="banner">
              <div>
                <upload
                  ref="upload2"
                  :fileList="uploadBanner"
                  :config="uploadBannerConfig"
                  @upload-ok="bannerBannerOK"
                />
              </div>
            </FormItem>
            <FormItem label="展会时间：">
              <Input v-model="formInline.time" />
            </FormItem>
            <FormItem label="英文展会时间：">
              <Input v-model="formInline.timeEn" />
            </FormItem>
            <FormItem label="展会地点：">
              <Input v-model="formInline.address" />
            </FormItem>
            <FormItem label="英文展会地点：">
              <Input v-model="formInline.addressEn" />
            </FormItem>
            <FormItem label="参展报名链接：">
              <Input v-model="formInline.exLink" />
            </FormItem>
            <FormItem label="参观报名链接：">
              <Input v-model="formInline.vLink" />
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :max="99999" :min="0" v-model="formInline.showIndex"></InputNumber>
              <p style="font-size:12px;">(数字越小在您的显示列表中显示越靠前)</p>
            </FormItem>
            <FormItem label="展会简介：">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 5}" v-model="formInline.description" />
            </FormItem>
            <FormItem label="英文展会简介：">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 5}" v-model="formInline.descriptionEn" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapGetters, mapActions } from "vuex";
import upload from "@components/upLoad/upLoad";

export default {
  name: "classify-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelTitle:{
      type:String,
    },
    options:{
      type:Object
    },
  },
  data() {
    const that = this;
    const validateLogo = (rule, value, callback) => {
      if (that.uploadLogo && that.uploadLogo.length) {
        callback();
      } else {
        callback(new Error("请上传Logo"));
      }
    };
    const validateCover = (rule, value, callback) => {
      if (that.uploadCover && that.uploadCover.length) {
        callback();
      } else {
        callback(new Error("请上传首页图片"));
      }
    };
    const validateBanner = (rule, value, callback) => {
      if (that.uploadBanner && that.uploadBanner.length) {
        callback();
      } else {
        callback(new Error("请上传内页图片"));
      }
    };
    return {
      uploadLogo: [],
      uploadCover: [],
      uploadBanner: [],

      loading: false,
      showModal: false,
      editId:'',
      formInline: {
        // form双向绑定
        name: "",
        nameEn: "",
        shortName: "",
        shortNameEn: "",
        time: "",
        timeEn: "",
        address: "",
        addressEn: "",
        description: "",
        descriptionEn: "",
        exLink: "",
        vLink: "",
        showIndex: 0,
      },
      ruleInline: {
        name: [{ required: true, message: "必填选项", trigger: "blur" }],
        nameEn: [{ required: true, message: "必填选项", trigger: "blur" }],
        shortName: [{ required: true, message: "必填选项", trigger: "blur" }],
        shortNameEn: [{ required: true, message: "必填选项", trigger: "blur" }],
        logo: [{ required: true, validator: validateLogo }],
        cover: [{ required: true, validator: validateCover }],
        banner: [{ required: true, validator: validateBanner }],
      },
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "（要求：2M以内的jpg，png格式图片，建议尺寸340*460px）",
        limitNum: 1
      },
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo(){
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    header() { return this.$store.state.header},
    uploadLogoConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_3";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    uploadCoverConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_2";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val){
      if(val.msg){
        this.formInline.name = val.msg.name;
        this.formInline.nameEn = val.msg.nameEn;
        this.formInline.shortName = val.msg.shortName;
        this.formInline.shortNameEn = val.msg.shortNameEn;
        this.formInline.time = val.msg.time;
        this.formInline.timeEn = val.msg.timeEn;
        this.formInline.address = val.msg.address;
        this.formInline.addressEn = val.msg.addressEn;
        this.formInline.description = val.msg.description;
        this.formInline.descriptionEn = val.msg.descriptionEn;
        this.formInline.exLink = val.msg.exLink;
        this.formInline.vLink = val.msg.vLink;
        this.formInline.showIndex = val.msg.showIndex;
        if (val.msg.logo) {
          this.uploadLogo.push(val.msg.logo);
        }
        if (val.msg.cover) {
          this.uploadCover.push(val.msg.cover);
        }
        if (val.msg.banner) {
          this.uploadBanner.push(val.msg.banner);
        }
        this.editId = val.msg.id;
      }
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addExPlan: "categoryModule/addExPlan",
      putExPlan: "categoryModule/putExPlan"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      
      this.loading = true;
      
      // 编辑模式
      if(this.options.model){ 
        this.editPro(form);
      } else { // 新增模式
        this.addPro(form);
      }
    },
    async addPro(form){
      let body = {
        "Logo": this.uploadLogo[0],
        "Cover": this.uploadCover[0],
        "Banner": this.uploadBanner[0],
        "Name": form.name,
        "NameEn": form.nameEn,
        "ShortName": form.shortName,
        "ShortNameEn": form.shortNameEn,
        // "Time": moment(form.time).format("YYYY-MM-DD"),
        "Time": form.time,
        "TimeEn": form.timeEn,
        "Address": form.address,
        "AddressEn": form.addressEn,
        "Description": form.description,
        "DescriptionEn": form.descriptionEn,
        "ExLink": form.exLink,
        "VLink": form.vLink,
        "ShowIndex": form.showIndex,
      }
      let bool = await this.addExPlan(body);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("添加成功！");
        this.cancel();
        this.$emit('finish');
      } else {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      }
    },
    async editPro(form){
      let body = {
          "Id":this.editId,
          "SetValues":{
            "Logo": this.uploadLogo[0],
            "Cover": this.uploadCover[0],
            "Banner": this.uploadBanner[0],
            "Name": form.name,
            "NameEn": form.nameEn,
            "ShortName": form.shortName,
            "ShortNameEn": form.shortNameEn,
            // "Time": moment(form.time).format("YYYY-MM-DD"),
            "Time": form.time,
            "TimeEn": form.timeEn,
            "Address": form.address,
            "AddressEn": form.addressEn,
            "Description": form.description,
            "DescriptionEn": form.descriptionEn,
            "ExLink": form.exLink,
            "VLink": form.vLink,
            "ShowIndex": form.showIndex,
          }
      }
      let bool = await this.putExPlan(body);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("修改成功！");
        this.cancel();
        this.$emit('finish');
      } else {
        this.loading = false;
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.formInline={
        name:'',
        nameEn:'',
        shortName:'',
        shortNameEn:'',
        time: "",
        timeEn: "",
        address:"",
        addressEn:"",
        description:'',
        descriptionEn:'',
        exLink: "",
        vLink: "",
        showIndex: 0
      };
      this.uploadLogo = [];
      this.uploadCover = [];
      this.uploadBanner = [];
      this.editId = '';
    },
    bannerLogoOK(list) {
      this.uploadLogo = list;
    },
    bannerOK(list) {
      this.uploadCover = list;
    },
    bannerBannerOK(list) {
      this.uploadBanner = list;
    }
  },
  components: {
    upload
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

